// // src/VideoCall.js
// import React, { useEffect, useState } from 'react';
// import { DailyVideo, useDaily, useDailyEvent, useParticipantIds } from '@daily-co/daily-react';
// import { LogOut, Mic, MicOff, Video, VideoOff } from 'lucide-react';
// import { cn } from '@/lib/utils';
// import { ControlButton } from './ControlButton';

// // circlecheck gia terminate
// // logout gia leave call (alla na mporei na ksanampei)

// const white = 'oklch(97% 0 0)';

// export const VideoDaily = ({ videoCallData, incident, meetingToken }) => {
// 	const daily = useDaily();
// 	const allIds = useParticipantIds();
// 	const participantIds = allIds.filter(id => id !== 'local');

// 	const participants = daily?.participants?.();
// 	delete participants?.local;

// 	console.log('participantIds', participantIds);
// 	console.log('participants', participants);

// 	const [joined, setJoined] = useState(false);
// 	const [isMicOn, setIsMicOn] = useState(true);
// 	const [isCamOn, setIsCamOn] = useState(true);

// 	useEffect(() => {
// 		if (!joined && daily && videoCallData?.url && meetingToken) {
// 			daily.join({ url: videoCallData.url, token: meetingToken });
// 		}
// 	}, [joined, daily, meetingToken, videoCallData.url]);

// 	const leave = () => daily?.leave();

// 	// useEffect(() => {
// 	// 	if (daily) {
// 	// 		daily.updateParticipant({
// 	// 			local: true,
// 	// 			user_name: videoCallData.userRole === 'doctor' ? 'Dr. Smith' : 'Patient',
// 	// 		});
// 	// 	}
// 	// }, [daily]);

// 	useEffect(() => {
// 		window.addEventListener('beforeunload', leave);
// 		return () => window.removeEventListener('beforeunload', leave);
// 	}, [daily]);

// 	const toggleMic = () => {
// 		const newMicState = !isMicOn;
// 		daily.setLocalAudio(newMicState);
// 		setIsMicOn(newMicState);
// 	};

// 	const toggleCam = () => {
// 		const newCamState = !isCamOn;
// 		daily.setLocalVideo(newCamState);
// 		setIsCamOn(newCamState);
// 	};

// 	const terminateCall = () => {
// 		daily.endMeeting();
// 	};

// 	useDailyEvent('joined-meeting', () => setJoined(true));
// 	useDailyEvent('left-meeting', () => setJoined(false));

// 	// tokens kai roles prota

// 	// daily.enumerateDevices() gives you options.
// 	// daily.setInputDevices() applies them.

// 	// Show participant names.

// 	// daily.startScreenShare();
// 	// daily.stopScreenShare();

// 	// 📷 10. Preview before joining

// 	//   Show local video + mic check before connecting to the call.
// 	// Use useDailyEvent('local-network-quality', ...) to show connection bars.

// 	const iconProps = {
// 		size: 26,
// 		strokeWidth: 2,
// 	};
// 	return (
// 		<div className='flex flex-col gap-y-8'>
// 			<h2>Incident ID: {incident.id}</h2>
// 			{joined ? (
// 				<>
// 					<div className='flex flex-row items-center'>
// 						<div className='flex flex-1 flex-row items-center gap-x-3'>
// 							<ControlButton
// 								text={isMicOn ? 'Mute' : 'Unmute'}
// 								icon={
// 									isMicOn ? (
// 										<Mic {...iconProps} />
// 									) : (
// 										<MicOff {...iconProps} color={!isMicOn && white} />
// 									)
// 								}
// 								cnContainer={cn(!isMicOn ? 'bg-red-500' : 'hover:bg-slate-200')}
// 								cnText={!isMicOn && 'text-neutral-100'}
// 								onClick={toggleMic}
// 							/>
// 							<ControlButton
// 								text={isCamOn ? 'Turn off' : 'Turn on'}
// 								icon={
// 									isCamOn ? (
// 										<Video {...iconProps} />
// 									) : (
// 										<VideoOff {...iconProps} color={!isCamOn && white} />
// 									)
// 								}
// 								onClick={toggleCam}
// 								cnContainer={cn(!isCamOn ? 'bg-red-500' : 'hover:bg-slate-200')}
// 								cnText={!isCamOn && 'text-neutral-100'}
// 							/>

// 							{/* <button onClick={terminateCall}>End Call </button> */}
// 						</div>
// 						<ControlButton text='Leave' icon={<LogOut {...iconProps} />} onClick={leave} />
// 					</div>

// 					<div className='relative flex flex-row gap-8'>
// 						{participantIds.map((id, idx) => (
// 							<>
// 								<DailyVideo key={id} sessionId={id} className='max-h-200 w-full max-w-200' />
// 								{id}
// 								<div className='absolute bottom-2 left-2 rounded bg-black/50 px-2 text-white'>
// 									{participants[id]?.user_name || ''}
// 								</div>
// 							</>
// 						))}
// 					</div>

// 					{/* <div className='relative flex flex-row gap-8'>
// 						{Object.keys(participants).map((key, idx) => {
// 							const participant = participants[key];
// 							return (
// 								<>
// 									<DailyVideo
// 										key={participant.sessionId}
// 										sessionId={participant.sessionId}
// 										className='max-h-200 max-w-200'
// 									/>
// 									<div className='absolute bottom-2 left-2 rounded bg-black/50 px-2 text-white'>
// 										{participant?.user_name || ''}
// 									</div>
// 								</>
// 							);
// 						})}
// 					</div> */}
// 				</>
// 			) : (
// 				<p>Joining...</p>
// 			)}
// 		</div>
// 	);
// };
import { useEffect } from 'react';
import DailyIframe from '@daily-co/daily-js';

export function VideoDaily({ videoCallData, incident, meetingToken }) {
	useEffect(() => {
		const container = document.getElementById('daily-embed');

		const frame = DailyIframe.createFrame(container, {
			showLeaveButton: true,
		});

		frame.join({
			url: videoCallData.url,
			token: meetingToken,
		});

		return () => frame.leave();
	}, [meetingToken, videoCallData.url]);

	return <div id='daily-embed' style={{ width: '100%', height: '100vh' }} />;
}
